import { render, staticRenderFns } from "./technology_detail.vue?vue&type=template&id=48060ae0&scoped=true&"
import script from "./technology_detail.vue?vue&type=script&lang=js&"
export * from "./technology_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48060ae0",
  null
  
)

export default component.exports